import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';

const Home = () => {
  return (
    <div>
      <Hero />
      <Services />
    </div>
  );
};

export default Home;
